<template>
  <Modal
    v-model="visible"
    width="600px"
    title="参与组织"
    :footer-hide="true"
    :loading="$root.$children[0].modalLoading"
    :mask-closable="false"
    class="my-modal top"
  >
    <loading :isShow="loading" />
    <orgTree ref="tree" v-model="arr" :isSelect="true" @getTreeData="getTreeData" source="1" :multiple="true" style="width: 100%; height: auto"></orgTree>

    <div class="ivu-modal-footer" v-if="isAllotOrg && !isDisabled">
      <Button type="primary" @click="visible = false" ghost>取消</Button>
      <Button type="primary" @click="ok" v-preventReClick>保存</Button>
    </div>
  </Modal>
</template>

<script>
import orgTree from '@/components/commons/orgTree/orgTree';
export default {
  components: { orgTree },
  props: [],
  data() {
    return {
      visible: false,
      arr: [],
      loading: false,
      isAllotOrg: '',
      status: '',
      calculateType: ''
    };
  },
  methods: {
    // 运营管理-展业端运营配置时isDisabled=true
    open(data, isDisabled) {
      this.isDisabled = isDisabled;
      if ((data.status == '-1' && !data.isAllotOrg && data.calculateType != '1') || (data.status != '-1' && data.calculateType != '1')) {
        this.isAllotOrg = true;
      } else if (data.status == '-1' && data.isAllotOrg || data.calculateType == '1') {
        this.isAllotOrg = false;
      }
      this.status = data.status;
      this.calculateType = data.calculateType;
      this.loading = true;
      this.visible = true;
      this.arr = ['99999'];
      this.$refs.tree.init('/buz/merchantActivity/queryOrganizationJoinTree', { activityId: data.id }, true);
    },
    ok() {
      this.$units.notCloseModal(this);
      const treeData = this.$refs.tree.treeData;
      const filterData = this.foreachTreeCheck(treeData);
      this.$http({
        url: '/buz/merchantActivity/saveOrganizationJoinTree',
        type: 'post',
        data: filterData[0]
      }).then(res => {
        this.$notice.success('保存成功');
        this.$parent.getList();
        this.visible = false;
      });
    },
    foreachTreeCheck(treeData) {
      treeData.forEach(item => {
        this.$set(item, 'isJoinMerchantActivity', item.checked ? 1 : 0);
        if (item.children && item.children.length) {
          this.foreachTreeCheck(item.children);
        }
      });
      return treeData;
    },
    getIds(treeData) {
      treeData.forEach(item => {
        if (item.isJoinMerchantActivity == 1) {
          this.arr.push(item.id);
        }
        if (this.isAllotOrg && this.status == '-1' || this.calculateType == '1' || this.isDisabled) {
          item.disabled = true;
        }
        if (item.children && item.children.length) {
          this.getIds(item.children);
        }
      });
    },
    getTreeData(treeData) {
      this.loading = false;
      this.getIds(treeData);
    }
  }
};
</script>
